import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip
} from '@mui/material';
import { DataGrid, trTR } from '@mui/x-data-grid';
import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { getDiscountedUser, AddOrUpdateDiscountedUser } from 'src/store/slices/dynamicCatalogSlice';
import { getUser } from 'src/utils/Common';
import AlertAndLoading from 'src/components/AlertAndLoading';
import DynamicListToolbar, { filterDynamicRows } from 'src/components/DynamicListToolbar';
import {
  ORANGE,
  darkButtonSx,
  dialogPaperProps,
  inputSx,
  lightButtonSx,
  statusChipSx,
  useDynamicStyles
} from 'src/components/dynamicCatalogStyles';

function DiscountedUserDynamic() {
  const classes = useDynamicStyles();
  const dispatch = useDispatch();
  const SessionUser = getUser();
  const [discountedUser, setDiscountedUser] = React.useState([]);
  const [updatePopUp, setUpdatePopUp] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [isDiscountedUserUpdate, setDiscountedUserUpdate] = React.useState(true);
  const [addOrUpdateDiscountedUserNameSurname, setaddOrUpdateDiscountedUserNameSurname] = React.useState("");
  const [addOrUpdateDiscountedUserIdentityNo, setaddOrUpdateDiscountedUserIdentityNo] = React.useState("");
  const [addOrUpdateDiscountedUserActive, setaddOrUpdateDiscountedUserActive] = React.useState(1);
  const [responseMessage, setresponseMessage] = React.useState('');
  const [uyari, setUyari] = React.useState(false);
  const [alertType, setAlertType] = React.useState({ ErrorType: 'error', ErrorTitle: 'Uyarı' });
  const [searchText, setSearchText] = React.useState('');
  const [statusFilter, setStatusFilter] = React.useState('all');

  const loadDiscountedUsers = () => {
    setLoading(true);
    dispatch(getDiscountedUser()).then(response => {
      if (response.payload?.length > 0) {
        setDiscountedUser(response.payload);
      }
      setLoading(false);
    })
  };

  useEffect(() => {
    loadDiscountedUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({
      ErrorType: ErrorType,
      ErrorTitle: ErrorTitle
    })
    setUyari(true);
    return
  }

  const updateDiscountedUserClick = (row) => {
    setDiscountedUserUpdate(true);
    setaddOrUpdateDiscountedUserIdentityNo(row.IDENTITY_NO);
    setaddOrUpdateDiscountedUserNameSurname(row.NAME_SURNAME);
    setaddOrUpdateDiscountedUserActive(row.ACTIVE);
    setUpdatePopUp(true);
  }
  function addDiscountedUserClick() {
    setDiscountedUserUpdate(false);
    clearAddOrUpdateDiscountedUser();
    setUpdatePopUp(true);
  }
  function closePopUp() {
    if (saving) return;
    setUpdatePopUp(false);
  }
  function addOrUpdateDiscountedUserClick() {
    if (!addOrUpdateDiscountedUserIdentityNo?.toString().trim() || !addOrUpdateDiscountedUserNameSurname?.toString().trim()) {
      InfoAlert('Lütfen Kutucukları Boş Bırakmayınız!...', 'error', 'Hata');
      return;
    }

    const data = {
      Identity_No: addOrUpdateDiscountedUserIdentityNo,
      Name_Surname: addOrUpdateDiscountedUserNameSurname,
      Active: addOrUpdateDiscountedUserActive === 1 ? true : false,
      Created_User: SessionUser?.UserId?.toString()
    }
    setSaving(true);
    dispatch(AddOrUpdateDiscountedUser(data)).then(() => {
      setSaving(false);
      setUpdatePopUp(false);
      clearAddOrUpdateDiscountedUser();
      loadDiscountedUsers();
    })
  }
  function clearAddOrUpdateDiscountedUser() {
    setaddOrUpdateDiscountedUserNameSurname("");
    setaddOrUpdateDiscountedUserIdentityNo("");
    setaddOrUpdateDiscountedUserActive(1);
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const activeCount = discountedUser.filter((r) => r.ACTIVE === 1).length;
  const passiveCount = discountedUser.length - activeCount;

  const filteredRows = useMemo(() => filterDynamicRows(discountedUser, {
    searchText,
    statusFilter,
    searchFields: ['IDENTITY_NO', 'NAME_SURNAME'],
    isActive: (r) => r.ACTIVE === 1
  }), [discountedUser, searchText, statusFilter]);

  const columns = [
    { field: 'IDENTITY_NO', headerName: 'Sicil No', flex: 1, minWidth: 140 },
    { field: 'NAME_SURNAME', headerName: 'Ad Soyad', flex: 1.5, minWidth: 180 },
    {
      field: 'ACTIVE', headerName: 'Durum', width: 120, align: 'center', headerAlign: 'center',
      renderCell: (cellValues) => (
        <Chip size="small" label={cellValues.row.ACTIVE === 1 ? 'Aktif' : 'Pasif'} sx={statusChipSx(cellValues.row.ACTIVE === 1)} />
      )
    },
    {
      field: 'Güncelle', headerName: 'İşlem', width: 90, align: 'center', headerAlign: 'center',
      sortable: false, filterable: false, disableColumnMenu: true,
      renderCell: (cellValues) => (
        <Tooltip title="Düzenle">
          <IconButton size="small" onClick={() => updateDiscountedUserClick(cellValues.row)}>
            <EditIcon sx={{ fontSize: 18, color: ORANGE }} />
          </IconButton>
        </Tooltip>
      )
    }
  ];

  const formEmpty = !addOrUpdateDiscountedUserIdentityNo?.toString().trim() || !addOrUpdateDiscountedUserNameSurname?.toString().trim();

  return (
    <>
      <AlertAndLoading Message={responseMessage} open={uyari} AlertType={alertType} onClose={uyariKapat} />
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          title="İndirim Talep Edilen Kişiler"
          subheader={loading ? 'Yükleniyor…' : `${discountedUser.length} kayıt · ${activeCount} aktif · ${passiveCount} pasif`}
          action={
            <Button startIcon={<AddIcon />} sx={darkButtonSx} onClick={addDiscountedUserClick}>
              Yeni Kişi
            </Button>
          }
        />
        <DynamicListToolbar
          searchText={searchText}
          onSearchChange={setSearchText}
          placeholder="Sicil no veya ad soyad ara"
          statusFilter={statusFilter}
          onStatusFilterChange={setStatusFilter}
          shownCount={filteredRows.length}
        />
        <DataGrid
          className={classes.grid}
          style={{ height: 520, width: '100%' }}
          columns={columns}
          rows={filteredRows}
          loading={loading}
          rowHeight={44}
          headerHeight={44}
          disableSelectionOnClick
          getRowId={(row) => row.DISCOUNTED_ID}
          localeText={{ ...trTR.components.MuiDataGrid.defaultProps.localeText, noRowsLabel: 'Kayıt bulunamadı.' }}
        />
      </Card>

      <Dialog
        open={updatePopUp}
        onClose={closePopUp}
        fullWidth
        maxWidth="xs"
        PaperProps={dialogPaperProps}
      >
        <DialogTitle className={classes.dialogTitle}>
          {isDiscountedUserUpdate ? 'Kişi Düzenle' : 'Yeni Kişi'}
          <IconButton size="small" onClick={closePopUp} disabled={saving}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '16px !important', opacity: saving ? 0.6 : 1, pointerEvents: saving ? 'none' : 'auto', transition: 'opacity 0.2s' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Sicil No"
              onChange={(e) => setaddOrUpdateDiscountedUserIdentityNo(e.target.value)}
              value={addOrUpdateDiscountedUserIdentityNo}
              size="small"
              fullWidth
              sx={inputSx}
              disabled={isDiscountedUserUpdate}
              helperText={isDiscountedUserUpdate ? 'Sicil no güncellemede değiştirilemez.' : ''}
              FormHelperTextProps={{ sx: { fontSize: '11px', mx: 0.5 } }}
            />
            <TextField
              label="Ad Soyad"
              onChange={(e) => setaddOrUpdateDiscountedUserNameSurname(e.target.value)}
              value={addOrUpdateDiscountedUserNameSurname}
              size="small"
              fullWidth
              sx={inputSx}
            />
            <Box className={classes.dialogSection}>
              <div className={classes.sectionLabel}>Durum</div>
              <ToggleButtonGroup
                exclusive
                size="small"
                className={classes.toggleGroup}
                value={addOrUpdateDiscountedUserActive}
                onChange={(e, v) => v !== null && setaddOrUpdateDiscountedUserActive(v)}
              >
                <ToggleButton value={1}>Aktif</ToggleButton>
                <ToggleButton value={0}>Pasif</ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button sx={lightButtonSx} onClick={closePopUp} disabled={saving}>Vazgeç</Button>
          <Button
            sx={{ ...darkButtonSx, minWidth: 110 }}
            onClick={addOrUpdateDiscountedUserClick}
            disabled={saving || formEmpty}
            startIcon={saving ? <CircularProgress size={14} sx={{ color: ORANGE }} /> : null}
          >
            {isDiscountedUserUpdate ? 'Güncelle' : 'Ekle'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DiscountedUserDynamic;
